<template>
  <div
    class="overlay modal-gallery pt-25 xl:pt-15 active"
    @click.prevent="$emit('close')"
    style="z-index: 1011"
  >
    <div class="wrapper-lightbox" @click.stop>
      <div class="close-modal -mr-4" @click.prevent="$emit('close')">
        <i class="fas fa-times"></i>
      </div>
      <div class="lightbox">
        <img v-if="cover" class="rounded-6 w-full" :src="cover" alt="" />
        <div v-for="(item, index) in gallery" :key="index">
          <img class="rounded-6 my-2 w-full" :src="item.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    cover: {
      type: String,
      required: true,
    },
    gallery: {
      type: Array,
      required: true,
    },
    currentSlide: {
      type: Number,
      required: true,
    },
    mi_vanguardia_id: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentSlie: 5,
      swiperOptionTop: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 16,
      },
      swiperOptionThumbs: {
        direction: "vertical",
        loop: true,
        // loopedSlides: 5,
        spaceBetween: 8,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
        breakpoints: {
          640: {
            spaceBetween: 12,
          },
          1024: {
            spaceBetween: 16,
          },
        },
      },
    };
  },
  methods: {
    isVideo(filename) {
      return /\.mp4$/i.test(filename);
    },
  },
  mounted() {},
};
</script>
